require('./LocationTooltip.less');
